/* eslint-disable camelcase */

import apiWrapper from 'common/api/api-wrapper';
import { IAPIErrorContent } from 'common/api/type-def';
import { CONTENT_TYPE } from 'common/constants';
import { getHeader } from 'common/utils/utilFunctions';

import { APIResponse } from 'features/AiSimulation/api/type-def';

import {
	IAIModelsList,
	IPromptBuilderResponseData,
	IPromptLocationResponseData,
	IPromptPayload,
	ITagsOptionsResponseData,
	ITestPayload,
} from './type-def';

const genAiServiceUrl = process.env.REACT_APP_GEN_AI_SERVICE_URL;

const { JSON } = CONTENT_TYPE;

export const getPromptTableData = async (params: any, searchText: string) => {
	const queryParams = {
		...params,
		...(params?.sortKey && { sortBy: params.sortKey }),
		...(params?.sortDirection && { sortOrder: params.sortDirection }),
		...('pageNumber' in params && { pageNumber: (params.pageNumber || 0) + 1 }),
		...(searchText && searchText !== '' && { query: searchText }),
	};

	const url = `${genAiServiceUrl}/prompts`;
	const resp = await apiWrapper.get<
		IPromptBuilderResponseData,
		IAPIErrorContent
	>(url, queryParams, JSON, getHeader());
	return resp;
};

export const addPrompt = async (key: string, payload: IPromptPayload) => {
	const resp = await apiWrapper.post<any, IAPIErrorContent>(
		`${genAiServiceUrl}/prompts/${key}`,
		payload,
		JSON,
		getHeader(),
	);
	return resp;
};

export const updatePrompt = async (key: string, payload: IPromptPayload) => {
	const resp = await apiWrapper.patch<any, IAPIErrorContent>(
		`${genAiServiceUrl}/prompts/${key}`,
		payload,
		JSON,
		getHeader(),
	);
	return resp;
};

export const deletePrompt = async (key: string) => {
	const resp = await apiWrapper.delete<any, IAPIErrorContent>(
		`${genAiServiceUrl}/prompts/${key}`,
		null,
		{},
		JSON,
		getHeader(),
	);
	return resp;
};

export const setDefaultPrompt = async (payload: any) => {
	const resp = await apiWrapper.patch<any, IAPIErrorContent>(
		`${genAiServiceUrl}/prompts/${payload.key}/active`,
		payload,
		JSON,
		getHeader(),
	);
	return resp;
};

export const fetchAIModelsOptions = async () => {
	const resp = await apiWrapper.get<IAIModelsList[], IAPIErrorContent>(
		`${genAiServiceUrl}/ai-models`,
		{},
		JSON,
		getHeader(),
	);
	return resp;
};

export const fetchTestResult = async (payload: ITestPayload) => {
	const resp = await apiWrapper.post<APIResponse, IAPIErrorContent>(
		`${genAiServiceUrl}/prompts/new-prompt/test`,
		payload,
		JSON,
		getHeader(),
	);
	return resp;
};

export const getPromptTagsData = async () => {
	const resp = await apiWrapper.get<ITagsOptionsResponseData, IAPIErrorContent>(
		`${genAiServiceUrl}/prompts/tags/all`,
		{},
		JSON,
		getHeader(),
	);
	return resp;
};

export const postPromptTagsData = async (name: string) => {
	const resp = await apiWrapper.post<APIResponse, IAPIErrorContent>(
		`${genAiServiceUrl}/prompts/tags/new`,
		{ name },
		JSON,
		getHeader(),
	);
	return resp;
};

export const getPromptLocation = async (aiModelKey: string) => {
	const resp = await apiWrapper.get<
		IPromptLocationResponseData,
		IAPIErrorContent
	>(
		`${genAiServiceUrl}/ai-models/${aiModelKey}/locations`,
		{},
		JSON,
		getHeader(),
	);
	return resp;
};
